<template>
	<div>
		<select 
			@change="changeClient" 
			v-model="clientId" 
			class="mt-0 form-select max-w-fit text-xs font-medium appearance-none rounded-lg px-3 py-1.5 cursor-pointer transition-all focus:outline-none focus:ring-2"
			style="background-color: var(--card); color: var(--foreground); border-color: var(--border);">
			<option 
				v-for="client in clients" :key="client.id" 
				:value="client.id" 
				class="pt-2"
				:style="{ backgroundColor: 'var(--card)', color: 'var(--foreground)' }">
				{{ client.name }}
			</option>
		</select>

		<notifications classes="notification" position="bottom right"></notifications>
	</div>
</template>

<script>
export default {
	props: {
		availableClients: {
			type: [Array, Object],
			required: true
		},

		selectedClientId: {
			type: Number,
			required: true
		}
	},

	data() {
		return {
			clients: this.availableClients,
			clientId: this.selectedClientId
		}
	},

	methods: {
		changeClient() {
			axios.post('/api/change-client', {
				client_id: this.clientId
			}).then(response => {
				this.$notify({
					type: 'success',
					title: 'Client Changed',
					text: 'Redirecting...'
				});

				setTimeout(() => {
					location.href = '/'
				}, 300)

			}).catch(error => {
				console.log(error);
			});
		}
	},
}
</script>
